import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { DataService } from '../../../../services/data.service';
import { BoltType } from '../../enums/bolt-type.enum';
import { TighteningMethod } from '../../enums/tightening-method.enum';
import { DiagramInfo } from '../../models/diagram-info';
import { ProcessInfoModel } from '../../models/process-info-model';
import { StdInputData } from '../../models/std-input-data';
import { Subject, takeUntil } from 'rxjs';
import { BoltDimensionModel, FlangeDimensionModel } from '../../models';
import { UserUtilityService } from '../../../../services/user-utility.service';
import { pipeSpecVersion } from 'src/app/Modules/settings/models/idms/pipe-specification.model';
import { Router } from '@angular/router';
import { MeasurementService } from 'src/app/services/measurement.service';
import { UnitType } from 'src/app/models/enums/unit-type.enum';
import { IdmsSharedService } from 'src/app/Modules/idms/services/idms-shared.service';
import { userActions } from '../../../../models/enums/user-permissions.enum';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';

@Component({
    selector: 'app-flange-input',
    templateUrl: './flange-input.component.html',
    styleUrls: ['./flange-input.component.scss'],
    standalone: false,
})
export class FlangeInputComponent implements OnInit, OnDestroy {
    @Input() isRedirect: boolean;
    @Input() pipeSpecVersion: pipeSpecVersion;
    @Input() enable: boolean;
    @Input() calculationType: any; // require when pipespec calc
    @Input() isPipeSpec: boolean = false;

    @Output() returnData: EventEmitter<StdInputData> = new EventEmitter();
    @Output() diagram: EventEmitter<DiagramInfo> = new EventEmitter();
    @Output() processInfo: EventEmitter<ProcessInfoModel> = new EventEmitter();
    @Output() isEditable: EventEmitter<boolean> = new EventEmitter();
    @Output() isOverriddenFlange: EventEmitter<boolean> = new EventEmitter();
    gasketSelectSubject: Subject<boolean>;
    destroy$ = new Subject();

    tooltip_position = 'above';
    standardId: string;
    pressureClassId: string;
    pipeSizeId: string;
    minPipeSizeId: string;
    maxPipeSizeId: string;
    flangeTypeId: string;
    flangeFacingTypeId: string;
    flangeMaterialId: string;
    boltMaterialId: string;
    boltType: string;
    pipesizeType: number = 0;
    gasketId: string;
    gasketTypeId: string;
    tighteningSpecification: string = 'Joint Assured Recommended';
    isCustom: boolean = false;
    isStandardFlange: boolean = true;
    isRTJ: boolean;
    flangeDiagramId: string;
    flangeFacingDiagramId: string;
    gasketDiagramId: string;
    boltDimensionId: string;
    doGasketReset: boolean = false;
    doFlangeMaterialReset: boolean = false;
    doBoltMaterialReset: boolean = false;
    stdInputFormGroup: UntypedFormGroup;
    flangeInput: StdInputData;
    enableAdvOpDefault: boolean = false;
    enableOverideDefault: boolean = false;
    flangeTypeId2: string;
    pipeScheduleId: string;
    washerThickness: string;
    isAddnlOverideDefault: boolean = false;
    addnlThicknessDefault: string = '0.00 mm';
    addnlOverideValueDefault: string = '0.00 mm';
    tighteningSpecOverideDefault: string;

    nutDimensionId: string;
    threadTypeDefault: string;
    boltQuantityDefault: number;
    minimumBoltDiameterDefault: string;
    recommendedGasketStressDefault: string;
    minimumGasketStressDefault: string;
    maximumGasketStressDefault: string;
    yDefault: string;
    mDefault: string;
    pAdditionalDefault: number;
    tighteningMethod: number;
    flangeDimension: FlangeDimensionModel[];
    isOverrideFlange: boolean = false;
    boltMaterialAliasId: string = '';
    flangeMaterialAliasId1: string = '';
    flangeMaterialAliasId2: string = '';
    gasketAliasId: string = '';
    constructor(
        private fb: UntypedFormBuilder,
        private dataSvc: DataService,
        private cd: ChangeDetectorRef,
        private globalEmittersService: GlobalEmittersService,
        private measSvc: MeasurementService,
        private user_utility: UserUtilityService,
        public router: Router,
        public idmsSharedService: IdmsSharedService,
        private jointCalcService: JointCalcService
    ) {
        this.gasketSelectSubject = new Subject();
    }

    async ngOnInit(): Promise<void> {
        this.isOverrideFlange = await this.user_utility.checkUserPermissionDataAndRoute('view-overriddenflange', userActions.View);

        this.flangeInput = new StdInputData();
        this.loadFormGroup();
        this.stdInputFormGroup = this.fb.group({
            standard: [this.standardId, Validators.required],
            pressureClass: [this.pressureClassId, Validators.required],
            pipeSize: [this.pipeSizeId],
            minPipeSize: [this.minPipeSizeId],
            maxPipeSize: [this.maxPipeSizeId],
            pipeSizeType: [this.pipesizeType],
            flangeType: [this.flangeTypeId, Validators.required],
            flangeFacingType: [this.flangeFacingTypeId, Validators.required],
            gasket: [this.gasketId, Validators.required],
            gasketType: [this.gasketTypeId],
            boltMaterial: [this.boltMaterialId, Validators.required],
            flangeMaterial: [this.flangeMaterialId, Validators.required],
            boltType: [this.boltType, Validators.required],

            tighteningSpecification: [this.tighteningSpecification, Validators.required],
            tighteningSpecOveride: [this.tighteningSpecOverideDefault, { updateOn: 'blur' }],
            enableAdvOp: [this.enableAdvOpDefault],
            enableOveride: [{ value: this.enableOverideDefault, disabled: true }],

            flangeType2: [this.flangeTypeId2],
            pipeSchedule: [this.pipeScheduleId],
            washer: [this.washerThickness],
            isAddnlOveride: [this.isAddnlOverideDefault],
            addnlThickness: [this.addnlThicknessDefault],
            addnlOverideValue: [this.addnlOverideValueDefault, { updateOn: 'blur' }],

            threadType: [this.threadTypeDefault],
            boltSize: [this.boltDimensionId],
            boltQuantity: [this.boltQuantityDefault, { updateOn: 'blur' }],
            isRedAreaBoltSelected: [false],
            redAreaBolt: [this.minimumBoltDiameterDefault, { updateOn: 'blur' }],
            nutStandard: [this.nutDimensionId],
            isRecGasketStress: [false], //checkBox for recGasketStress
            recGasketStress: [this.recommendedGasketStressDefault, { updateOn: 'blur' }],
            isMinGasketStress: [false], //checkBox for minGasketStress
            minGasketStress: [this.minimumGasketStressDefault, { updateOn: 'blur' }],
            isMaxGasketStress: [false], //checkBox for maxGasketStress
            maxGasketStress: [this.maximumGasketStressDefault, { updateOn: 'blur' }],
            isy: [false], //checkBox for y
            y: [this.yDefault, { updateOn: 'blur' }],
            ism: [false], //checkBox for m
            m: [this.mDefault],
            ispAdditional: [false],
            pAdditional: [this.pAdditionalDefault, [Validators.min(1), Validators.max(2)]],

            isRTJ: [false],
            flangeDiagramId: [''],
            flangeFacingDiagramId: [''],
            gasketDiagramId: [''],
            boltMaterialAliasId: [this.boltMaterialAliasId],
            flangeMaterialAliasId1: [this.flangeMaterialAliasId1],
            flangeMaterialAliasId2: [this.flangeMaterialAliasId2],
            gasketAliasId: [this.gasketAliasId],
        });
        // this.stdInputFormGroup.patchValue({
        //     enableAdvOp: this.enableAdvOpDefault,
        // });
        // if(this.enable==true){
        //   this.stdInputFormGroup.disable();
        // }
        //Only for PipeSpec
        const pipeScheduleControl = this.stdInputFormGroup.get('pipeSchedule');

        if (this.isPipeSpec) {
            pipeScheduleControl?.addValidators(Validators.required);
        } else {
            pipeScheduleControl?.removeValidators(Validators.required);
        }

        // update validity
        pipeScheduleControl?.updateValueAndValidity();
        //Only for PipeSpec End

        this.handleOverriddenFlangeFromMatrix();

        this.stdInputFormGroup.markAllAsTouched();
        this.globalEmittersService.standardInputForm.next(this.stdInputFormGroup);

        this.stdInputFormGroup
            .get('standard')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                this.standardId = value;
                this.setPrestine('standard');
                // this.globalEmittersService.refreshTools.next(true); //Due to Load from matrix Tool Selection
            });

        this.stdInputFormGroup
            ?.get('pressureClass')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.pressureClassId = value), this.emitProcessInfoModel(), this.setPrestine('pressureClass')]);

        this.stdInputFormGroup
            ?.get('pipeSize')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.pipeSizeId = value), this.setPrestine('pipeSize')]);

        this.stdInputFormGroup
            ?.get('minPipeSize')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.minPipeSizeId = value), this.setPrestine('minPipeSize')]);

        this.stdInputFormGroup
            ?.get('maxPipeSize')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.maxPipeSizeId = value), this.setPrestine('maxPipeSize')]);

        this.stdInputFormGroup
            ?.get('flangeType')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.flangeTypeId = value), this.setPrestine('flangeType')]);

        this.stdInputFormGroup
            ?.get('flangeFacingType')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.flangeFacingTypeId = value), this.setPrestine('flangeFacingType')]);
        this.stdInputFormGroup
            ?.get('isRTJ')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => (this.isRTJ = value));

        this.stdInputFormGroup
            ?.get('flangeMaterial')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                this.flangeMaterialId = value;
                this.emitProcessInfoModel();
                this.setPrestine('flangeMaterial');
                this.doFlangeMaterialReset = false;
            });
        if (this.flangeMaterialId) {
            this.stdInputFormGroup?.get('flangeMaterial').setValue(this.flangeMaterialId);
        }
        this.stdInputFormGroup
            .get('gasket')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                this.gasketId = value;
                this.setPrestine('gasket');
                this.doGasketReset = false;
                if (value) {
                    this.gasketSelectSubject.next(true);
                } else {
                    this.gasketSelectSubject.next(false);
                }
            });

        this.stdInputFormGroup
            .get('gasketType')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => (this.gasketTypeId = value));

        this.stdInputFormGroup
            ?.get('tighteningSpecification')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.tighteningSpecification = value), this.setPrestine('tighteningSpecification')]);

        this.stdInputFormGroup
            ?.get('enableAdvOp')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => this.setAdditionalInfoValidators(value));

        this.stdInputFormGroup
            .get('isAddnlOveride')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                this.setAddnlThicknessValidators(value);
            });

        this.stdInputFormGroup
            .get('enableOveride')
            .valueChanges.pipe()
            .subscribe((value) => {
                this.setOverideValidators(value);
                this.setIsOverriddenFlange(value);
                this.setPrestine('enableOveride');
                this.isOverriddenFlange.emit(value);
            });

        this.stdInputFormGroup
            .get('boltSize')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => [(this.boltDimensionId = value), this.setPrestine('boltSize')]);
        //Diagrams
        this.stdInputFormGroup
            ?.get('flangeDiagramId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => this.emitDiagramEvent('Flange', value));
        this.stdInputFormGroup
            ?.get('flangeFacingDiagramId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => this.emitDiagramEvent('Flange Facing', value));
        this.stdInputFormGroup
            ?.get('gasketDiagramId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => this.emitDiagramEvent('Gasket', value));

        this.stdInputFormGroup
            ?.get('boltQuantity')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => this.emitDiagramEvent('Torque Sequence', null, value));

        // if(this.router.url=="/settings/idms"){
        // this.stdInputFormGroup.setValue(this.stdInputFormGroup.value)
        // this.stdInputFormGroup.updateValueAndValidity();
        // }
        this.stdInputFormGroup.get('ispAdditional').valueChanges.subscribe((value) => {
            if (value) {
                this.stdInputFormGroup.get('pAdditional').setValidators([Validators.min(1), Validators.max(2)]);
                this.stdInputFormGroup.get('pAdditional')?.updateValueAndValidity();
            } else {
                this.stdInputFormGroup.get('pAdditional').clearValidators();
                this.stdInputFormGroup.get('pAdditional')?.updateValueAndValidity();
            }
        });
        this.stdInputFormGroup.markAllAsTouched();

        this.globalEmittersService.tighteningProcedureForm.pipe(takeUntil(this.destroy$)).subscribe((form: UntypedFormGroup) => {
            if (form) {
                form.get('calcMethod')
                    .valueChanges.pipe(takeUntil(this.destroy$))
                    .subscribe((methodType: string) => {
                        this.tighteningMethod = methodType.toLowerCase() == 'tension' ? TighteningMethod.Tension : TighteningMethod.Torque;
                        if (this.stdInputFormGroup.get('flangeDiagramId').value != undefined && this.tighteningMethod == TighteningMethod.Torque) {
                            setTimeout(() => {
                                this.emitDiagramEvent('Flange', this.stdInputFormGroup.get('flangeDiagramId').value, null);
                            }, 1100);
                        }
                    });
            }
        });

        this.gasketSelectSubject.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (this.idmsSharedService.enableConfirmWithRouter(1) == true) {
                if (res && this.isRedirect.toString() == 'false') {
                    this.stdInputFormGroup.get('enableOveride').enable();
                } else {
                    this.stdInputFormGroup.get('enableOveride').disable();
                }
            }
        });

        this.globalEmittersService.flangeDimension.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.flangeDimension = res;
            }
        });

        this.globalEmittersService.unitUpdated.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp) {
                this.emitDiagramEvent('Flange', this.stdInputFormGroup.get('flangeDiagramId').value);
                // this.emitDiagramEvent('Flange', this.stdInputFormGroup.value.flangeDiagramId);
                this.emitDiagramEvent('Flange Facing', this.stdInputFormGroup.value.flangeFacingDiagramId);
                this.emitDiagramEvent('Gasket', this.stdInputFormGroup.value.gasketDiagramId);
            }
        });

        this.cd.markForCheck();
        if (this.idmsSharedService.enableConfirmWithRouter(2) == true) {
            // Subscribe to valueChanges and emit the form when it changes
            this.stdInputFormGroup.valueChanges.subscribe((formValue) => {
                this.btnStdInputConfirmClicked();
            });
        }
    }

    loadFormGroup() {
        if (this.isRedirect && this.dataSvc.calculationData != null) {
            this.standardId = this.dataSvc.calculationData.input.recordId.standardId;
            this.pressureClassId = this.dataSvc.calculationData.input.recordId.pressureClassId;
            this.pipeSizeId = this.dataSvc.calculationData.input.recordId.pipeSizeId;
            this.flangeTypeId = this.dataSvc.calculationData.input.recordId.flangeTypeId1;
            this.flangeFacingTypeId = this.dataSvc.calculationData.input.recordId.flangeFacingTypeId;

            this.flangeMaterialId = this.dataSvc.calculationData.input.recordId.flangeMaterialId1;
            this.boltMaterialId = this.dataSvc.calculationData.input.recordId.boltMaterialId;

            this.boltMaterialAliasId = this.dataSvc.calculationData.input.recordId.boltMaterialAliasId;
            this.flangeMaterialAliasId1 = this.dataSvc.calculationData.input.recordId.flangeMaterialAliasId1;
            this.flangeMaterialAliasId2 = this.dataSvc.calculationData.input.recordId.flangeMaterialAliasId2;
            this.gasketAliasId = this.dataSvc.calculationData.input.recordId.gasketAliasId;
            this.gasketId = this.dataSvc.calculationData.input.recordId.gasketId;
            this.globalEmittersService.selectedGasketId.next(this.gasketId);
            this.boltType = this.dataSvc.calculationData.input.others.boltType == 1 ? 'Imperial' : 'Metric';
            this.tighteningSpecification = this.dataSvc.calculationData.input.others.tighteningSpecification;
            if (this.tighteningSpecification !== 'Joint Assured Recommended') {
                this.tighteningSpecOverideDefault = this.dataSvc.calculationData.input.others.tighteningSpecificationInput;
            }
            if (this.dataSvc.calculationData.input.recordId.pipeScheduleId) {
                this.enableAdvOpDefault = true;

                this.flangeTypeId2 = this.dataSvc.calculationData.input.recordId.flangeTypeId2;
                this.pipeScheduleId = this.dataSvc.calculationData.input.recordId.pipeScheduleId;
                this.washerThickness = this.dataSvc.calculationData.input.recordId.washerDimensionId;

                if (this.dataSvc.calculationData.input.recordId.additionalThicknessId) {
                    this.isAddnlOverideDefault = false;
                    this.addnlThicknessDefault = this.dataSvc.calculationData.input.recordId.additionalThicknessId;
                } else if (this.dataSvc.calculationData.input.calculationOverrides.additionalThickness === '0.00 mm') {
                    this.isAddnlOverideDefault = false;
                    this.addnlThicknessDefault = '0.00 mm';
                } else if (this.dataSvc.calculationData.input.calculationOverrides.additionalThickness) {
                    this.isAddnlOverideDefault = true;
                    this.addnlOverideValueDefault = this.dataSvc.calculationData.input.calculationOverrides.additionalThickness;
                }
            }
            if (this.dataSvc.calculationData.input.recordId.boltDimensionId) {
                // this.stdInputFormGroup.get('enableOveride').enable();
                this.globalEmittersService.updateStandardFlangeHeader.next(true); // * for changing the sub header heading
                this.enableOverideDefault = true;
                this.threadTypeDefault = this.dataSvc.calculationData.input.others.threadType;
                this.boltDimensionId = this.dataSvc.calculationData.input.recordId.boltDimensionId;
                this.nutDimensionId = this.dataSvc.calculationData.input.recordId.nutDimensionId;
                this.boltQuantityDefault = this.dataSvc.calculationData.input.others.boltQuantity;
                this.minimumBoltDiameterDefault = this.dataSvc.calculationData.input.calculationOverrides.minimumBoltDiameter;
                this.recommendedGasketStressDefault = this.measSvc.format(
                    this.dataSvc.calculationData.input.calculationOverrides.recommendedGasketStress,
                    UnitType.DefaultStressUnit
                );
                this.minimumGasketStressDefault = this.measSvc.format(
                    this.dataSvc.calculationData.input.calculationOverrides.minimumGasketStress,
                    UnitType.DefaultStressUnit
                );
                this.maximumGasketStressDefault = this.measSvc.format(
                    this.dataSvc.calculationData.input.calculationOverrides.maximumGasketStress,
                    UnitType.DefaultStressUnit
                );
                this.yDefault = this.measSvc.format(this.dataSvc.calculationData.input.calculationOverrides.y, UnitType.DefaultStressUnit);
                this.mDefault = this.dataSvc.calculationData.input.calculationOverrides.m;
                this.pAdditionalDefault = this.dataSvc.calculationData.input.calculationOverrides.pAdditional;

                if (this.dataSvc.calculationData.input.others.tighteningMethod == TighteningMethod.Torque)
                    if (this.boltQuantityDefault !== undefined) {
                        setTimeout(() => {
                            this.emitDiagramEvent('Torque Sequence', null, this.boltQuantityDefault);
                        }, 1100);
                    }
            }
        }

        if (this.idmsSharedService.enableConfirmWithRouter(2) == true && this.pipeSpecVersion) {
            this.standardId = this.pipeSpecVersion?.recordId?.standardId;
            this.pressureClassId = this.pipeSpecVersion?.recordId?.pressureClassId;
            //Pipesize is pending
            this.minPipeSizeId = this.pipeSpecVersion?.minimumPipeSizeId;
            this.maxPipeSizeId = this.pipeSpecVersion?.maximumPipeSizeId;
            this.flangeTypeId = this.pipeSpecVersion?.recordId?.flangeTypeId;
            this.flangeFacingTypeId = this.pipeSpecVersion?.recordId?.flangeFacingTypeId;
            this.flangeMaterialId = this.pipeSpecVersion?.recordId?.flangeMaterialId;
            this.boltMaterialId = this.pipeSpecVersion?.recordId?.boltMaterialId;
            this.gasketId = this.pipeSpecVersion?.recordId?.gasketId;

            this.pipesizeType = this.pipeSpecVersion?.pipeSizeType;
            this.boltType = this.pipeSpecVersion?.others?.boltType == 1 ? 'Imperial' : 'Metric';
            this.tighteningSpecification = this.pipeSpecVersion?.others?.tighteningSpecification;

            this.pipeScheduleId = this.pipeSpecVersion?.recordId?.pipeScheduleId;

            if (this.tighteningSpecification !== 'Joint Assured Recommended') {
                this.tighteningSpecOverideDefault = this.pipeSpecVersion?.others?.tighteningSpecificationInput;
            }
        }
    }

    setPrestine(controlName: string): void {
        switch (controlName) {
            case 'standard':
                this.isEditable.emit(false);
                this.stdInputFormGroup.get('pressureClass').reset('', { emitEvent: false });
                this.stdInputFormGroup.get('pipeSize').reset('', { emitEvent: false });
                this.stdInputFormGroup.get('flangeType').reset('', { emitEvent: false });
                this.stdInputFormGroup.get('flangeFacingType').reset('', { emitEvent: false });
                this.stdInputFormGroup.get('gasket').reset('', { emitEvent: true });
                this.doGasketReset = true;
                // this.stdInputFormGroup.get('boltMaterial').reset('', { emitEvent: false });
                // this.doBoltMaterialReset = true;
                // this.stdInputFormGroup.get('flangeMaterial').reset('', { emitEvent: false });
                // this.doFlangeMaterialReset = true;

                if (this.jointCalcService.isPipeCode) {
                    this.stdInputFormGroup.get('boltType').reset('', { emitEvent: false });
                    this.stdInputFormGroup.get('flangeMaterial').reset('', { emitEvent: false });
                    this.doFlangeMaterialReset = true;
                    this.stdInputFormGroup.get('boltMaterial').reset('', { emitEvent: false });
                    this.doBoltMaterialReset = true;
                    this.flangeMaterialId = this.boltType = this.boltMaterialId = undefined;
                }
                // if (!this.jointCalcService.isPipeCode && this.isRedirect?.toString() != 'true') {
                //     this.stdInputFormGroup.get('enableAdvOp').reset('', { emitEvent: false });
                // }

                this.stdInputFormGroup.get('enableOveride').reset('', { emitEvent: false });
                this.pressureClassId =
                    this.pipeSizeId =
                    this.flangeTypeId =
                    this.flangeFacingTypeId =
                    this.boltMaterialId =
                    this.gasketId =
                    this.gasketTypeId =
                    this.tighteningSpecification =
                    this.flangeDiagramId =
                    this.flangeFacingDiagramId =
                    this.gasketDiagramId =
                    this.boltDimensionId =
                    this.isRTJ =
                    this.flangeDiagramId =
                    this.flangeFacingDiagramId =
                    this.gasketDiagramId =
                    this.boltDimensionId =
                        undefined;
                this.setPrestineAdditinalInfo();
                this.setPrestineOverrideFlangeInfo();

                //* When flange type is change diagram should be removed
                this.emitDiagramEvent('Flange', null);
                this.emitDiagramEvent('Flange Facing', null);
                this.emitDiagramEvent('Gasket', null);

                this.emitDiagramEvent('Torque Sequence', null, null);
                if (!this.jointCalcService.isPipeCode && this.isRedirect?.toString() != 'true') {
                    if (this.dataSvc.tightningSpecList?.length > 0) {
                        this.dataSvc.tightningSpecList.forEach((x) => {
                            if (x.name == 'Informate Recommended') {
                                this.stdInputFormGroup.get('tighteningSpecification').reset('Informate Recommended', { emitEvent: true });
                            } else if (x.name == 'Joint Assured Recommended') {
                                this.stdInputFormGroup.get('tighteningSpecification').reset('Joint Assured Recommended', { emitEvent: true });
                            }
                        });
                    }
                }

                break;
            case 'pressureClass':
                this.isEditable.emit(false);
                this.stdInputFormGroup.get('pipeSize').reset('', { emitEvent: false });
                this.stdInputFormGroup.get('flangeType').reset('', { emitEvent: false });
                this.stdInputFormGroup.get('flangeFacingType').reset('', { emitEvent: false });
                this.stdInputFormGroup.get('gasket').reset('', { emitEvent: true });
                this.doGasketReset = true;

                if (this.jointCalcService.isPipeCode) {
                    this.stdInputFormGroup.get('minPipeSize').reset('', { emitEvent: false });
                    this.stdInputFormGroup.get('maxPipeSize').reset('', { emitEvent: false });

                    this.stdInputFormGroup.get('boltType').reset('', { emitEvent: false });
                    this.stdInputFormGroup.get('flangeMaterial').reset('', { emitEvent: false });
                    this.doFlangeMaterialReset = true;
                    this.stdInputFormGroup.get('boltMaterial').reset('', { emitEvent: false });
                    this.doBoltMaterialReset = true;

                    this.flangeMaterialId = this.boltType = this.boltMaterialId = undefined;
                }
                // if (!this.jointCalcService.isPipeCode && this.isRedirect?.toString() != 'true') {
                //     this.stdInputFormGroup.get('enableAdvOp').reset('', { emitEvent: false });
                // }
                this.stdInputFormGroup.get('enableOveride').reset('', { emitEvent: false });
                this.pipeSizeId =
                    this.flangeTypeId =
                    this.flangeFacingTypeId =
                    this.boltMaterialId =
                    this.gasketId =
                    this.gasketTypeId =
                    this.tighteningSpecification =
                    this.flangeDiagramId =
                    this.flangeFacingDiagramId =
                    this.gasketDiagramId =
                    this.boltDimensionId =
                    this.isRTJ =
                    this.flangeDiagramId =
                    this.flangeFacingDiagramId =
                    this.gasketDiagramId =
                    this.boltDimensionId =
                        undefined;

                this.setPrestineAdditinalInfo();
                this.setPrestineOverrideFlangeInfo();
                if (!this.jointCalcService.isPipeCode && this.isRedirect?.toString() != 'true') {
                    if (this.dataSvc.tightningSpecList?.length > 0) {
                        this.dataSvc.tightningSpecList.forEach((x) => {
                            if (x.name == 'Informate Recommended') {
                                this.stdInputFormGroup.get('tighteningSpecification').reset('Informate Recommended', { emitEvent: true });
                            } else if (x.name == 'Joint Assured Recommended') {
                                this.stdInputFormGroup.get('tighteningSpecification').reset('Joint Assured Recommended', { emitEvent: true });
                            }
                        });
                    }
                }
                // this.stdInputFormGroup.get('tighteningSpecification').reset('Joint Assured Recommended', { emitEvent: false });

                //* When flange type is change diagram should be removed
                this.emitDiagramEvent('Flange', null);
                this.emitDiagramEvent('Flange Facing', null);
                this.emitDiagramEvent('Gasket', null);
                // this.emitDiagramEvent("Torque Sequence", null, null);

                break;
            case 'pipeSize':
                this.isEditable.emit(false);
                this.stdInputFormGroup.get('flangeType').reset('', { emitEvent: false });
                this.stdInputFormGroup.get('flangeFacingType').reset('', { emitEvent: false });
                this.stdInputFormGroup.get('gasket').reset('', { emitEvent: true });
                this.doGasketReset = true;

                // this.stdInputFormGroup.get('flangeMaterial').reset('', { emitEvent: false });
                // this.doFlangeMaterialReset = true;

                // if (!this.jointCalcService.isPipeCode && this.isRedirect?.toString() != 'true') {
                //     this.stdInputFormGroup.get('enableAdvOp').reset('', { emitEvent: false });
                // }
                this.stdInputFormGroup.get('enableOveride').reset('', { emitEvent: false });
                if (this.jointCalcService.isPipeCode) {
                    this.stdInputFormGroup.get('boltType').reset('', { emitEvent: false });
                    this.stdInputFormGroup.get('flangeMaterial').reset('', { emitEvent: false });
                    this.doFlangeMaterialReset = true;

                    this.stdInputFormGroup.get('boltMaterial').reset('', { emitEvent: false });
                    this.doBoltMaterialReset = true;

                    this.flangeMaterialId = this.boltType = this.boltMaterialId = undefined;
                }
                this.flangeTypeId =
                    this.flangeFacingTypeId =
                    this.boltMaterialId =
                    this.gasketId =
                    this.gasketTypeId =
                    this.tighteningSpecification =
                    this.flangeDiagramId =
                    this.flangeFacingDiagramId =
                    this.gasketDiagramId =
                    this.boltDimensionId =
                    this.isRTJ =
                    this.flangeDiagramId =
                    this.flangeFacingDiagramId =
                    this.gasketDiagramId =
                    this.boltDimensionId =
                        undefined;

                this.setPrestineAdditinalInfo();
                this.setPrestineOverrideFlangeInfo();
                if (!this.jointCalcService.isPipeCode && this.isRedirect?.toString() != 'true') {
                    if (this.dataSvc.tightningSpecList?.length > 0) {
                        this.dataSvc.tightningSpecList.forEach((x) => {
                            if (x.name == 'Informate Recommended') {
                                this.stdInputFormGroup.get('tighteningSpecification').reset('Informate Recommended', { emitEvent: true });
                            } else if (x.name == 'Joint Assured Recommended') {
                                this.stdInputFormGroup.get('tighteningSpecification').reset('Joint Assured Recommended', { emitEvent: true });
                            }
                        });
                    }
                }
                // this.stdInputFormGroup.get('tighteningSpecification').reset('Joint Assured Recommended', { emitEvent: false });

                //* When flange type is change diagram should be removed
                this.emitDiagramEvent('Gasket', null);
                this.emitDiagramEvent('Flange', null);
                this.emitDiagramEvent('Flange Facing', null);

                // this.emitDiagramEvent("Torque Sequence", null, null);
                break;
            case 'flangeType':
                this.isEditable.emit(false);
                // this.stdInputFormGroup.get('flangeFacingType').reset('', { emitEvent: false }); //it reset flangeFacingType after upadte flangeType
                this.stdInputFormGroup.get('gasket').reset('', { emitEvent: true });
                this.doGasketReset = true;
                // this.stdInputFormGroup.get('boltMaterial').reset('', { emitEvent: false });
                // this.doBoltMaterialReset = true;
                // this.stdInputFormGroup.get('flangeMaterial').reset('', { emitEvent: false });
                // this.doFlangeMaterialReset = true;
                // if (!this.jointCalcService.isPipeCode && this.isRedirect?.toString() != 'true') {
                //     this.stdInputFormGroup.get('enableAdvOp').reset('', { emitEvent: false });
                // }
                this.stdInputFormGroup.get('enableOveride').reset('', { emitEvent: false });

                this.flangeFacingTypeId =
                    this.boltMaterialId =
                    this.gasketId =
                    this.gasketTypeId =
                    this.tighteningSpecification =
                    this.flangeDiagramId =
                    this.flangeFacingDiagramId =
                    this.gasketDiagramId =
                    this.boltDimensionId =
                    this.isRTJ =
                    this.flangeDiagramId =
                    this.flangeFacingDiagramId =
                    this.gasketDiagramId =
                    this.boltDimensionId =
                        undefined;

                // if (this.stdInputFormGroup.get('enableAdvOp').value) {
                this.stdInputFormGroup.get('flangeType2').setValue(this.flangeTypeId);
                this.stdInputFormGroup.get('flangeType2')?.updateValueAndValidity();
                // }

                this.setPrestineAdditinalInfo();
                this.setPrestineOverrideFlangeInfo();
                if (!this.jointCalcService.isPipeCode && this.isRedirect?.toString() != 'true') {
                    if (this.dataSvc.tightningSpecList?.length > 0) {
                        this.dataSvc.tightningSpecList.forEach((x) => {
                            if (x.name == 'Informate Recommended') {
                                this.stdInputFormGroup.get('tighteningSpecification').reset('Informate Recommended', { emitEvent: true });
                            } else if (x.name == 'Joint Assured Recommended') {
                                this.stdInputFormGroup.get('tighteningSpecification').reset('Joint Assured Recommended', { emitEvent: true });
                            }
                        });
                    }
                }
                // this.stdInputFormGroup.get('tighteningSpecification').reset('Joint Assured Recommended', { emitEvent: false });

                this.emitDiagramEvent('Flange Facing', null);
                this.emitDiagramEvent('Gasket', null);
                break;
            case 'flangeFacingType':
                if (this.jointCalcService.isPipeCode) {
                    this.stdInputFormGroup.get('gasket').reset('', { emitEvent: true });
                    this.doGasketReset = true;
                    this.stdInputFormGroup.get('boltType').reset('', { emitEvent: false });
                    this.stdInputFormGroup.get('boltMaterial').reset('', { emitEvent: false });
                    this.doBoltMaterialReset = true;
                    this.boltMaterialId = this.gasketId = this.gasketTypeId = this.gasketDiagramId = undefined;
                    this.emitDiagramEvent('Gasket', null);
                }
                break;
            case 'boltType':
                if (!this.jointCalcService.isPipeCode) {
                    this.stdInputFormGroup.get('washer')?.reset('0', { emitEvent: false });
                } else {
                    if (!this.stdInputFormGroup.get('enableAdvOp').value) {
                        this.stdInputFormGroup.get('washer')?.reset('0', { emitEvent: false });
                    }
                }
                this.stdInputFormGroup.get('threadType')?.reset('', { emitEvent: false });
                this.stdInputFormGroup.get('boltSize')?.reset('', { emitEvent: false });
                this.stdInputFormGroup.get('nutStandard')?.reset('', { emitEvent: false });
                break;
            case 'threadType':
                this.stdInputFormGroup.get('boltSize')?.reset('', { emitEvent: false });
                this.stdInputFormGroup.get('nutStandard')?.reset('', { emitEvent: false });
                break;
            case 'boltSize':
                this.stdInputFormGroup.get('nutStandard')?.reset('', { emitEvent: false });
                break;
            case 'enableOveride':
                if (!this.stdInputFormGroup.get('enableOveride').value) {
                    this.setPrestineOverrideFlangeInfo();
                    //This is to reinitiate the 'Torgue Sequence' diagram based on Flange Dimension.
                    this.emitDiagramEvent('Flange', this.stdInputFormGroup.get('flangeDiagramId').value);
                    // this.emitDiagramEvent('Flange', this.stdInputFormGroup.value.flangeDiagramId);
                    this.emitDiagramEvent('Flange Facing', this.stdInputFormGroup.value.flangeFacingDiagramId);
                    this.emitDiagramEvent('Gasket', this.stdInputFormGroup.value.gasketDiagramId);
                }
                break;            
        }
        this.stdInputFormGroup.markAllAsTouched();
    }

    setPrestineAdditinalInfo() {
        // if (!this.jointCalcService.isPipeCode) {
        //     this.stdInputFormGroup.get('flangeType2')?.reset('', { emitEvent: false });
        //     this.stdInputFormGroup.get('pipeSchedule')?.reset('', { emitEvent: false });
        //     this.stdInputFormGroup.get('washer')?.reset('0', { emitEvent: false });
        //     this.stdInputFormGroup.get('isAddnlOveride')?.reset('', { emitEvent: false });
        //     this.stdInputFormGroup.get('addnlThickness')?.reset('0.00 mm', { emitEvent: false });
        //     this.stdInputFormGroup.get('addnlOverideValue')?.reset('0.00 mm', { emitEvent: false });
        // }
        // else {
        if (!this.stdInputFormGroup.get('enableAdvOp').value) {
            this.stdInputFormGroup.get('flangeType2')?.reset('', { emitEvent: false });
            this.stdInputFormGroup.get('flangeType2')?.setValidators(null);
            this.stdInputFormGroup.get('flangeType2')?.updateValueAndValidity();

            this.stdInputFormGroup.get('pipeSchedule')?.reset('', { emitEvent: false });
            this.stdInputFormGroup.get('pipeSchedule')?.setValidators(null);
            this.stdInputFormGroup.get('pipeSchedule')?.updateValueAndValidity();

            this.stdInputFormGroup.get('washer')?.reset('0', { emitEvent: false });
            this.stdInputFormGroup.get('isAddnlOveride')?.reset('', { emitEvent: false });
            this.stdInputFormGroup.get('addnlThickness')?.reset('0.00 mm', { emitEvent: false });
            this.stdInputFormGroup.get('addnlOverideValue')?.reset('0.00 mm', { emitEvent: false });
        }
        // }
    }

    setPrestineOverrideFlangeInfo() {
        this.stdInputFormGroup.get('threadType').reset('', { emitEvent: false });
        this.stdInputFormGroup.get('boltSize').reset('', { emitEvent: false });
        this.stdInputFormGroup.get('boltQuantity').reset('', { emitEvent: false });
        this.stdInputFormGroup.get('redAreaBolt').reset('', { emitEvent: false });
        this.stdInputFormGroup.get('nutStandard').reset('', { emitEvent: false });
        this.stdInputFormGroup.get('recGasketStress').reset('', { emitEvent: false });
        this.stdInputFormGroup.get('minGasketStress').reset('', { emitEvent: false });
        this.stdInputFormGroup.get('maxGasketStress').reset('', { emitEvent: false });
        this.stdInputFormGroup.get('y').reset('', { emitEvent: false });
        this.stdInputFormGroup.get('m').reset('', { emitEvent: false });
        this.stdInputFormGroup.get('pAdditional').reset('', { emitEvent: false });
    }

    setAdditionalInfoValidators(isAddnlInfoEnabled: boolean): void {
        this.stdInputFormGroup.get('enableAdvOp').setValue(isAddnlInfoEnabled, { emitEvent: false });
        if (isAddnlInfoEnabled) {
            this.stdInputFormGroup.get('flangeType2').setValidators([Validators.required]);
            this.stdInputFormGroup.get('flangeType2').setValue(this.flangeTypeId);
            this.stdInputFormGroup.get('pipeSchedule').setValidators([Validators.required]);
            this.stdInputFormGroup.get('washer').setValidators([Validators.required]);
        } else {
            this.stdInputFormGroup.get('flangeType2').setValidators(null);
            this.stdInputFormGroup.get('pipeSchedule').setValidators(null);
            this.stdInputFormGroup.get('washer').setValidators(null);
            this.stdInputFormGroup.get('flangeType2')?.reset(this.flangeTypeId, { emitEvent: false });
            this.stdInputFormGroup.get('pipeSchedule')?.reset('', { emitEvent: false });
            this.stdInputFormGroup.get('washer')?.reset('0', { emitEvent: false });
            this.stdInputFormGroup.get('isAddnlOveride')?.reset('', { emitEvent: false });
            this.stdInputFormGroup.get('addnlThickness')?.reset('0.00 mm', { emitEvent: false });
            this.stdInputFormGroup.get('addnlOverideValue')?.reset('0.00 mm', { emitEvent: false });
        }
        this.stdInputFormGroup.get('flangeType2').updateValueAndValidity({ onlySelf: false });
        this.stdInputFormGroup.get('pipeSchedule').updateValueAndValidity({ onlySelf: false });
        this.stdInputFormGroup.get('washer').updateValueAndValidity({ onlySelf: false });
    }

    setAddnlThicknessValidators(isAddnlThicknessEnabled: boolean): void {
        if (isAddnlThicknessEnabled) {
            this.stdInputFormGroup.get('addnlOverideValue').setValidators([Validators.required]);
            this.stdInputFormGroup.get('addnlThickness').setValidators(null);
        } else {
            this.stdInputFormGroup.get('addnlThickness').setValidators([Validators.required]);
            this.stdInputFormGroup.get('addnlOverideValue').setValidators(null);
        }
        this.stdInputFormGroup.get('addnlOverideValue').updateValueAndValidity();
        this.stdInputFormGroup.get('addnlThickness').updateValueAndValidity();
    }

    setOverideValidators(isOverrideEnabled: boolean): void {
        if (isOverrideEnabled) {
            this.stdInputFormGroup.get('boltQuantity').setValidators([Validators.required, Validators.min(1), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]);

            this.globalEmittersService.updateStandardFlangeHeader.next(true); // * for changing the sub header heading
            // * setting up the required inputs value
            if (this.flangeDimension) {
                if (this.stdInputFormGroup.get('boltType').value.toLowerCase() === 'imperial') {
                    this.stdInputFormGroup.get('threadType').patchValue(this.flangeDimension[0].boltDimensionImperial.threadSeries);
                    this.stdInputFormGroup.get('boltSize').patchValue(this.flangeDimension[0].boltDimensionImperial.boltDimensionId);
                } else if (this.stdInputFormGroup.get('boltType').value === 'metric') {
                    this.stdInputFormGroup.get('threadType').patchValue(this.flangeDimension[0].boltDimensionMetric.threadSeries);
                    this.stdInputFormGroup.get('boltSize').patchValue(this.flangeDimension[0].boltDimensionMetric.boltDimensionId);
                }
                this.stdInputFormGroup.get('boltQuantity').patchValue(this.flangeDimension[0].numberOfBolts);
            } else if (this.dataSvc.calculationData.input.recordId?.boltDimensionId) {
                this.stdInputFormGroup.get('threadType').patchValue(this.dataSvc.calculationData.input.others.threadType);
                this.stdInputFormGroup.get('boltSize').patchValue(this.dataSvc.calculationData.input.recordId.boltDimensionId);
                this.stdInputFormGroup.get('boltQuantity').patchValue(this.dataSvc.calculationData.input.others.boltQuantity);
            }
            // * disable the inputs if override flange
            this.stdInputFormGroup.get('standard').disable({ emitEvent: false });
            this.stdInputFormGroup.get('pressureClass').disable({ emitEvent: false });
            this.stdInputFormGroup.get('pipeSize').disable({ emitEvent: false });
            this.stdInputFormGroup.get('flangeType').disable({ emitEvent: false });
            this.stdInputFormGroup.get('flangeFacingType').disable({ emitEvent: false });
        } else {
            this.stdInputFormGroup.get('boltQuantity').setValidators(null);
            this.globalEmittersService.updateStandardFlangeHeader.next(false);
            // * enable the inputs if the override flange uncheck
            this.stdInputFormGroup.get('standard').enable({ emitEvent: false });
            this.stdInputFormGroup.get('pressureClass').enable({ emitEvent: false });
            this.stdInputFormGroup.get('pipeSize').enable({ emitEvent: false });
            this.stdInputFormGroup.get('flangeType').enable({ emitEvent: false });
            this.stdInputFormGroup.get('flangeFacingType').enable({ emitEvent: false });
        }
        this.stdInputFormGroup.get('boltQuantity').updateValueAndValidity({ emitEvent: false });
    }

    btnStdInputConfirmClicked(): void {
        this.stdInputFormGroup.markAllAsTouched();
        this.stdInputFormGroup.markAsDirty();
        if (this.stdInputFormGroup.valid) {
            this.flangeInput.standardId = this.stdInputFormGroup.get('standard').value;
            this.flangeInput.pressureClassId = this.stdInputFormGroup.get('pressureClass').value;
            this.flangeInput.pipeSizeId = this.stdInputFormGroup.get('pipeSize').value;
            this.flangeInput.flangeTypeId1 = this.flangeInput.flangeTypeId2 = this.stdInputFormGroup.get('flangeType').value;
            this.flangeInput.flangeFacingTypeId = this.stdInputFormGroup.get('flangeFacingType').value;
            this.flangeInput.flangeMaterialId1 = this.stdInputFormGroup.get('flangeMaterial').value;
            this.flangeInput.gasketId = this.stdInputFormGroup.get('gasket').value;
            this.flangeInput.boltMaterialId = this.stdInputFormGroup.get('boltMaterial').value;
            this.flangeInput.boltMaterialAliasId = this.stdInputFormGroup.get('boltMaterialAliasId').value;
            this.flangeInput.flangeMaterialAliasId1 = this.stdInputFormGroup.get('flangeMaterialAliasId1').value;
            this.flangeInput.flangeMaterialAliasId2 = this.stdInputFormGroup.get('flangeMaterialAliasId2').value;
            this.flangeInput.gasketAliasId = this.stdInputFormGroup.get('gasketAliasId').value;

            this.flangeInput.boltType = this.stdInputFormGroup.get('boltType').value;
            this.flangeInput.tighteningSpecification = this.stdInputFormGroup.get('tighteningSpecification').value;

            if (this.flangeInput.tighteningSpecification != 'Joint Assured Recommended') {
                this.flangeInput.tighteningSpecificationInput = this.stdInputFormGroup.get('tighteningSpecOveride').value;
            }

            if (this.stdInputFormGroup.get('enableAdvOp').value) {
                this.flangeInput.flangeTypeId2 = this.stdInputFormGroup.get('flangeType2').value;
                this.flangeInput.pipeScheduleId = this.stdInputFormGroup.get('pipeSchedule').value;
                if (this.stdInputFormGroup.get('washer').value != 0) {
                    this.flangeInput.washerThickness = this.stdInputFormGroup.get('washer').value;
                } else {
                    delete this.flangeInput.washerThickness;
                }
                if (this.stdInputFormGroup.get('isAddnlOveride').value) {
                    this.flangeInput.additionalThickness = this.stdInputFormGroup.get('addnlOverideValue').value;
                } else if (this.stdInputFormGroup.get('addnlThickness').value === '0.00 mm') {
                    this.flangeInput.additionalThickness = this.stdInputFormGroup.get('addnlThickness').value;
                } else {
                    this.flangeInput.additionalThicknessId = this.stdInputFormGroup.get('addnlThickness').value;
                }
            } else {
                this.flangeInput.washerThickness = '';
                this.flangeInput.pipeScheduleId = '';
                this.flangeInput.flangeTypeId2 = this.flangeInput.flangeTypeId1;
                this.flangeInput.additionalThickness = '';
                this.flangeInput.additionalThicknessId = '';
            }
            if (this.stdInputFormGroup.get('enableOveride').value) {
                this.flangeInput.threadType = this.stdInputFormGroup.get('threadType').value;
                this.flangeInput.boltDimensionId = this.stdInputFormGroup.get('boltSize').value;
                this.flangeInput.boltQuantity = this.stdInputFormGroup.get('boltQuantity').value;
                this.flangeInput.nutDimensionId = this.stdInputFormGroup.get('nutStandard').value;
                this.flangeInput.minimumBoltDiameter = this.stdInputFormGroup.get('redAreaBolt').value;
                this.flangeInput.recommendedGasketStress = this.stdInputFormGroup.get('recGasketStress').value;

                this.flangeInput.recommendedGasketStress = this.stdInputFormGroup.get('isRecGasketStress').value
                    ? this.stdInputFormGroup.get('recGasketStress').value
                    : null;
                this.flangeInput.minimumGasketStress = this.stdInputFormGroup.get('isMinGasketStress').value
                    ? this.stdInputFormGroup.get('minGasketStress').value
                    : null;
                this.flangeInput.maximumGasketStress = this.stdInputFormGroup.get('isMaxGasketStress').value
                    ? this.stdInputFormGroup.get('maxGasketStress').value
                    : null;
                this.flangeInput.y = this.stdInputFormGroup.get('isy').value ? this.stdInputFormGroup.get('y').value : null;
                this.flangeInput.m = this.stdInputFormGroup.get('ism').value ? this.stdInputFormGroup.get('m').value : null;
                this.flangeInput.pAdditional = this.stdInputFormGroup.get('ispAdditional').value ? this.stdInputFormGroup.get('pAdditional').value : null;

                this.flangeInput.isRedAreaBoltSelected = this.stdInputFormGroup.get('isRedAreaBoltSelected')?.value;
                if (this.stdInputFormGroup.get('isRedAreaBoltSelected').value == true) {
                    this.flangeInput.minimumBoltDiameter = this.stdInputFormGroup.get('redAreaBolt')?.value;
                }
                this.flangeInput.isDataValid = true;
                // this.returnData.emit(this.flangeInput);
            }
            this.flangeInput.isDataValid = true;
            this.returnData.emit(this.flangeInput);
        } else {
            this.flangeInput.isDataValid = false;
        }
    }

    emitDiagramEvent(diagramType: string, diagramId: string, noOfBolts: number = 0) {
        let diagramInfo = new DiagramInfo();
        diagramInfo.diagramId = diagramId;
        diagramInfo.diagramType = diagramType;
        diagramInfo.flangeTypeId = this.flangeTypeId;
        diagramInfo.pressureClassId = this.pressureClassId;
        diagramInfo.pipesizeId = this.pipeSizeId;
        diagramInfo.flangeFacingTypeId = this.flangeFacingTypeId;
        diagramInfo.gasketTypeId = this.gasketTypeId;
        diagramInfo.noOfBolts = noOfBolts;
        diagramInfo.boltType = this.boltType;
        this.diagram.emit(diagramInfo);
    }

    setIsOverriddenFlange(value: boolean) {
        this.isEditable.emit(value);
    }

    setBoltType(defaultBoltType: BoltType) {
        this.boltType = defaultBoltType === 0 ? 'Metric' : 'Imperial';
        this.stdInputFormGroup.get('boltType').setValue(this.boltType, { emitEvent: true });
    }

    emitProcessInfoModel() {
        this.processInfo.emit({ standardId: this.standardId, flangeMaterialId: this.flangeMaterialId, pressureClassId: this.pressureClassId });
    }

    // * handling override flange calculation when loading from matrix
    handleOverriddenFlangeFromMatrix(): void {
        if (this.isRedirect?.toString() == 'true') {
            this.isOverriddenFlange.emit(true);
            this.stdInputFormGroup.get('enableOveride').enable();
        } else if (this.isRedirect?.toString() == 'false') {
            this.stdInputFormGroup.get('enableOveride').disable();
        }
        if (this.enableOverideDefault) {
            // * disable the inputs if override flange
            this.stdInputFormGroup.get('standard').disable({
                emitEvent: false,
            });
            this.stdInputFormGroup.get('pressureClass').disable({
                emitEvent: false,
            });
            this.stdInputFormGroup.get('pipeSize').disable({
                emitEvent: false,
            });
            this.stdInputFormGroup.get('flangeType').disable({
                emitEvent: false,
            });
            this.stdInputFormGroup.get('flangeFacingType').disable({
                emitEvent: false,
            });
        } else {
            // * enable the inputs if the override flange uncheck
            this.stdInputFormGroup.get('standard').enable({
                emitEvent: false,
            });
            this.stdInputFormGroup.get('pressureClass').enable({
                emitEvent: false,
            });
            this.stdInputFormGroup.get('pipeSize').enable({
                emitEvent: false,
            });
            this.stdInputFormGroup.get('flangeType').enable({
                emitEvent: false,
            });
            this.stdInputFormGroup.get('flangeFacingType').enable({
                emitEvent: false,
            });
        }
    }

    onSelectedBoltType(selected: string) {
        this.stdInputFormGroup.get('redAreaBolt').setValue('', { emitEvent: false });
        this.emitDiagramEvent('Flange', this.stdInputFormGroup.get('flangeDiagramId').value);
    }

    onSelectedBoltSize(selected: BoltDimensionModel) {
        this.stdInputFormGroup.get('redAreaBolt').setValue('', { emitEvent: false });
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
